import { Route } from '@angular/router';

import { GearRepository } from '@softapps/werkstatt/garage-core';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { ToolRepository } from './repository/tool.repository';
import { VehicleRepository } from '@softapps/werkstatt/garage-core';
import { CustomGearService } from '@softapps/werkstatt/garage-core';
import { ToolService } from './services/tool.service';
import { VehicleService } from '@softapps/werkstatt/garage-core';

const routes = () => [
  {
    path: 'create',
    loadComponent: () =>
      import('./pages/vehicle-create/vehicle-create.component').then(
        (o) => o.VehicleCreateComponent
      ),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./pages/vehicle-detail/vehicle-detail.component').then(
        (o) => o.VehicleDetailComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/vehicle-search/vehicle-search.component').then(
        (o) => o.VehicleSearchComponent
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

export const vehicleRoutes: Route[] = [
  {
    path: 'vehicle',
    loadComponent: () => import('./pages/vehicle.component'),
    providers: [
      { provide: GearRepository, useClass: VehicleRepository },
      { provide: CustomGearService, useClass: VehicleService },
    ],
    loadChildren: routes,
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {
      permission: 'GARAGE.VEHICLES',
    },
  },
  {
    path: 'tool',
    loadComponent: () => import('./pages/vehicle.component'),
    providers: [
      { provide: GearRepository, useClass: ToolRepository },
      { provide: CustomGearService, useClass: ToolService },
    ],
    loadChildren: routes,
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {
      permission: 'GARAGE.TOOLS',
    },
  },
];
